export default function DiamondsLeft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 559 1408">
      <rect
        width="230"
        height="230"
        x="-145.4"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 -145 0)"
      />
      <rect
        width="230"
        height="230"
        x="34.9"
        y="180.3"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 35 180)"
      />
      <rect
        width="230"
        height="230"
        x="215.2"
        y="360.6"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 215 361)"
      />
      <rect
        width="230"
        height="230"
        x="395.5"
        y="540.9"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 396 541)"
      />
      <rect
        width="230"
        height="230"
        x="-55.3"
        y="450.8"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 -55 451)"
      />
      <rect
        width="230"
        height="230"
        x="125"
        y="631.1"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 125 631)"
      />
      <rect
        width="230"
        height="230"
        x="-145.4"
        y="721.2"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 -145 721)"
      />
      <rect
        width="230"
        height="230"
        x="34.9"
        y="901.6"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 35 902)"
      />
    </svg>
  )
}
